import { client } from "./client";
import type { LoginResponse, RegisterResponse, User } from "./types";

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const { data } = await client.post<LoginResponse>("/auth/login", {
      email,
      password,
    });
    return data;
  },

  async register(payload: {
    email: string;
    password: string;
    display_name: string;
    department?: string;
  }): Promise<RegisterResponse> {
    const { data } = await client.post<RegisterResponse>("/auth/register", payload);
    return data;
  },

  async me(): Promise<User> {
    const { data } = await client.get<User>("/auth/me");
    return data;
  },

  async logout(): Promise<void> {
    try {
      await client.post("/auth/logout");
    } catch {
      // サーバ側にセッションがなくても問題なし
    }
  },
};
